import { TimeZoneEnum } from "../../enums";
import { IRideStationTimingComparisonBasis } from "../../models";
import { getHourWindowInTimezone } from "../date.helpers";

/**
 * The single anchor a ride comparison is built on, together with everything derived from it.
 * The form's `rideStart` may still be unsaved, so the anchor is sent to the backend as
 * `comparisonAt` instead of letting the persisted ride date decide: the hour window filtered on, the
 * hours named in the caption and the date type the backend resolves then all come from this one
 * timestamp and cannot describe different rides.
 * `undefined` means the form carries no usable date — the caller must not ask for stats at all, since
 * a request without an anchor is served unfiltered.
 */
export const getRideStationTimingComparisonBasis = ({
  rideStart,
  timezone,
  hoursSpread,
}: {
  rideStart: TDateISO | undefined;
  timezone: TimeZoneEnum;
  hoursSpread: number;
}): IRideStationTimingComparisonBasis | undefined => {
  if (!rideStart) {
    return undefined;
  }

  const hourWindow = getHourWindowInTimezone({
    dateISO: rideStart,
    timezone,
    hoursSpread,
  });

  if (!hourWindow) {
    return undefined;
  }

  return { comparisonAt: rideStart, hourWindow };
};
